import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { compact } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { getBuildAndPriceLink } from 'site-modules/shared/utils/build-and-price-link-constructor';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';
import { PUB_STATES } from 'client/constants/pub-states';

export function AppraisalNoOfferLinks({ getVehicleData, toggleAppraiserDrawer = null }) {
  const { makeName, modelName, year, modelSlug, makeSlug, publicationState } = getVehicleData();

  if (compact([makeName, modelName, year, modelSlug, makeSlug]).length !== 5) return null;
  return (
    <div>
      <h3 className="heading-4 mb-1">
        Learn more about the {year} {makeName} {modelName}
      </h3>
      <ul className="list-unstyled">
        <li className="mb-1">
          <Link
            to={getCoreUrl({
              makeSlug,
              modelSlug,
            })}
            className="text-primary-darker"
          >
            Read Reviews for the {makeName} {modelName}
          </Link>
        </li>
        {[PUB_STATES.NEW, PUB_STATES.NEW_USED].includes(publicationState) && (
          <li className="mb-1">
            <Link
              to={getBuildAndPriceLink({
                make: makeSlug,
                model: modelSlug,
                year,
              })}
              className="text-primary-darker"
            >
              Build &amp; Price a New {makeName} {modelName}
            </Link>
          </li>
        )}
        <li className="mb-1">
          <Link to={srpLinkBuilder({ make: makeSlug, model: modelSlug })} className="text-primary-darker">
            Browse Inventory for a {makeName} {modelName} near you
          </Link>
        </li>
        <li>
          {!toggleAppraiserDrawer ? (
            <Link to={URL_PATHS.APPRAISAL_LANDING} className="text-primary-darker">
              Start Over
            </Link>
          ) : (
            <Button
              color="default"
              className="text-primary-darker btn-bg-white p-0 m-0 text-capitalize size-16 border-0"
              onClick={toggleAppraiserDrawer}
            >
              Start Over
            </Button>
          )}
        </li>
      </ul>
    </div>
  );
}

AppraisalNoOfferLinks.propTypes = {
  getVehicleData: PropTypes.func.isRequired,
  toggleAppraiserDrawer: PropTypes.func,
};
